import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shareModal", "publishTemplateModal"]
  static values = { inloopId: String, updateUrl: String }

  syncStatus(event) {
    const { id, status, badge_html, select_html } = event.detail
    if (id !== this.inloopIdValue) return

    const badge = this.element.querySelector('[data-inloop-status-badge]')
    const select = this.element.querySelector('[data-inloop-status-select]')
    if (badge) badge.innerHTML = badge_html
    if (select) {
      select.innerHTML = select_html
      const form = select.closest('form')
      const autoSave = form && this.application.getControllerForElementAndIdentifier(form, 'auto-save')
      // Only this field was saved remotely; keep other unsaved edits dirty.
      if (autoSave?.originalFormData) {
        const original = JSON.parse(autoSave.originalFormData)
        original['inloop[status]'] = status
        autoSave.originalFormData = JSON.stringify(original)
        autoSave.updateButtonState()
      }
    }
  }

  openShareModal() {
    if (this.hasShareModalTarget) {
      this.shareModalTarget.classList.remove("hidden")
    }
  }

  closeShareModal() {
    if (this.hasShareModalTarget) {
      this.shareModalTarget.classList.add("hidden")
    }
  }

  openPublishTemplateModal() {
    if (this.hasPublishTemplateModalTarget) {
      this.publishTemplateModalTarget.classList.remove("hidden")
    }
  }

  closePublishTemplateModal() {
    if (this.hasPublishTemplateModalTarget) {
      this.publishTemplateModalTarget.classList.add("hidden")
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
